import FocusPoster from "./FocusPoster";
export default FocusPoster;
